export const WhatsAppIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_14)">
      <path
        d="M20 40C8.956 40 0 31.044 0 20C0 8.956 8.956 0 20 0C31.044 0 40 8.956 40 20C40 31.044 31.044 40 20 40Z"
        fill="#25D366"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.356 10.688C26.876 8.204 23.572 6.836 20.056 6.832C12.812 6.832 6.91199 12.728 6.91199 19.976C6.91199 22.292 7.51599 24.556 8.66799 26.548L6.80399 33.36L13.772 31.532C15.692 32.58 17.852 33.132 20.052 33.132H20.056C27.3 33.132 33.196 27.236 33.2 19.988C33.204 16.476 31.84 13.172 29.356 10.688ZM20.06 30.912H20.056C18.096 30.912 16.172 30.384 14.496 29.388L14.096 29.152L9.95999 30.236L11.064 26.204L10.804 25.792C9.71199 24.052 9.13199 22.044 9.13199 19.976C9.13599 13.952 14.036 9.052 20.064 9.052C22.984 9.052 25.724 10.192 27.788 12.256C29.852 14.32 30.988 17.068 30.984 19.984C30.984 26.012 26.08 30.912 20.06 30.912ZM26.052 22.728C25.724 22.564 24.108 21.768 23.808 21.66C23.508 21.552 23.288 21.496 23.068 21.824C22.848 22.152 22.22 22.892 22.028 23.112C21.836 23.332 21.644 23.36 21.316 23.196C20.988 23.032 19.928 22.684 18.676 21.564C17.7 20.692 17.04 19.616 16.848 19.288C16.656 18.96 16.828 18.78 16.992 18.616C17.14 18.468 17.32 18.232 17.484 18.04C17.648 17.848 17.704 17.712 17.812 17.492C17.92 17.272 17.868 17.08 17.784 16.916C17.7 16.752 17.044 15.136 16.772 14.476C16.504 13.836 16.236 13.924 16.032 13.912C15.84 13.904 15.62 13.9 15.404 13.9C15.184 13.9 14.828 13.984 14.528 14.312C14.228 14.64 13.38 15.436 13.38 17.052C13.38 18.668 14.556 20.232 14.72 20.448C14.884 20.668 17.036 23.984 20.332 25.408C21.116 25.748 21.728 25.948 22.204 26.1C22.992 26.352 23.708 26.316 24.272 26.232C24.904 26.136 26.216 25.436 26.488 24.672C26.76 23.904 26.76 23.248 26.68 23.112C26.6 22.976 26.38 22.896 26.052 22.728Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_14">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
